import PropTypes from 'prop-types';
import { Button } from '@carbon/react';
import { ArrowLeft, Add, Settings, Renew } from '@carbon/react/icons';
import 'carbon-components/css/carbon-components.min.css'; // Import Carbon core CSS
import './_page-layout.scss';
import headerLogoFallback from '../../assets/logo.png';

const PageLayout = props => {
  const {
    pageHeader,
    pageDesc,
    tag,
    headerLogo,
    showBackButton,
    handleBackButtonClick,
    showPrimaryActionButton,
    handleActionClick,
    actionButtonText,
    footerContent,
    children,
    isCompanySettingsPage = false,
    isEditing = false,
    handleEditActionClick,
    handleUpdateActionClick,
    handleCancelActionClick,
  } = props;

  return (
    <div className="page-layout">
      <div className="page-header">
        <div className="page-header-container">
          {showBackButton && (
            <div className="page-back">
              <Button
                kind="ghost"
                id="back-button"
                renderIcon={() => <ArrowLeft size={28} />}
                iconDescription="Back"
                hasIconOnly
                onClick={handleBackButtonClick}
                tooltipPosition="bottom"
              />
            </div>
          )}
          <div
            className="info-container"
            style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {headerLogo && (
              <img
                src={headerLogo}
                alt="Logo"
                className="header-logo"
                style={{ height: '60px' }}
                onError={e => {
                  e.currentTarget.onerror = null; // prevent infinite loop
                  if (headerLogoFallback)
                    e.currentTarget.src = headerLogoFallback;
                  else e.currentTarget.style.display = 'none';
                }}
              />
            )}
            <div className="info-text">
              <div className="info-heading">
                {pageHeader}
                {tag}
              </div>
              {!!pageDesc && <div className="info-desc">{pageDesc}</div>}
            </div>
          </div>
          {showPrimaryActionButton && (
            <div className="button-container">
              <Button renderIcon={Add} id="add-new" onClick={handleActionClick}>
                {actionButtonText}
              </Button>
            </div>
          )}

          {isCompanySettingsPage && (
            <div className="button-container">
              {!isEditing ? (
                <Button
                  renderIcon={Settings}
                  id="edit-settings-btn"
                  onClick={handleEditActionClick}>
                  Edit
                </Button>
              ) : (
                <>
                  <Button
                    id="cancel-btn"
                    onClick={handleCancelActionClick}
                    style={{
                      marginRight: '10px',
                      backgroundColor: 'black',
                      color: 'white',
                    }}>
                    Cancel
                  </Button>
                  <Button
                    renderIcon={Renew}
                    id="reload-btn"
                    onClick={handleUpdateActionClick}>
                    Update Settings
                  </Button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="page-content">{children}</div>
      {!!footerContent && <div className="page-footer">{footerContent}</div>}
    </div>
  );
};

PageLayout.propTypes = {
  pageHeader: PropTypes.string.isRequired,
  pageDesc: PropTypes.string,
  headerLogo: PropTypes.string,
  showBackButton: PropTypes.bool,
  handleBackButtonClick: PropTypes.func,
  showPrimaryActionButton: PropTypes.bool,
  handleActionClick: PropTypes.func,
  actionButtonText: PropTypes.string,
  footerContent: PropTypes.element,
  children: PropTypes.node,
  tag: PropTypes.node,
};

PageLayout.defaultProps = {
  showBackButton: false,
  handleBackButtonClick: () => {},
  showPrimaryActionButton: false,
  handleActionClick: () => {},
  actionButtonText: 'Add New',
};

export default PageLayout;
